// currently not in use ---> we can keep a copy of configuration locally in react project.
// Notes - If we update only locally in configurations, we need to rebuild the project again.

const LocalConfig = {
    mpaasWebCorporateUrl: 'http://localhost:7070',
}

const DefaultConfig = LocalConfig;

export {DefaultConfig, LocalConfig};